// extracted by mini-css-extract-plugin
export var bulk = "styles-module--bulk--b82f2";
export var center = "styles-module--center--f6213";
export var loading = "styles-module--loading--b7b22";